<nz-breadcrumb>
  <nz-breadcrumb-item *ngFor="let card of cards$ | async; let i = index">
    {{ card?.title | translate }}
  </nz-breadcrumb-item>
</nz-breadcrumb>
